export const $cubic1 = "cubicBezier(0.74, 0.04, 0.34, 0.95)";
export const $easeInOutExpo = "cubicBezier(0.9, 0, 0.1, 1)";
